import { useState, useEffect } from "react";
import "./styles/PanelCis.css";
import Search from "../generales/Search";
import Action from "../Action";
import Modal from "react-modal";
import ModalCreateCis from "./ModalCreateCis";
import CisList from "./CisList";
import LoadSimple from "../LoadSimple";
import TableCis from "./Software/TableCis";
import InfoCis from "./InfoCis";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Paginador from "../generales/Paginador";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "35%",
    height: "40%",
    padding: "20px",
  },
};
const PanelProvSoft = ({ server,languaje,mode,handleShowPopup,
  
  cisSelected, setCisSelected
 }) => {
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: false,
    
    error: null,
  });
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);

  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [searchResult, setSearchResult] = useState(null);
  const [listSelected,setListSelected]=useState(1)
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const hadleChangeList=(e)=>{
      setListSelected(e)
  }
  const handleSearch = (query) => {
      // Aquí puedes realizar la búsqueda usando el valor de 'query'
      // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
      setSearchResult(`Resultados para: ${query}`);
    };
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;

  // console.log(dataUsers);
  // const [searchResult, setSearchResult] = useState(null);

  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);

  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };
  useEffect(() => {
    setPageActual(1);
  }, [dataList]);
  // const handleSearch = (query) => {
  //   // Aquí puedes realizar la búsqueda usando el valor de 'query'
  //   // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
  //   setSearchResult(`Resultados para: ${query}`);
  // };
  // const crear = () => {
  //   // Aquí puedes realizar la búsqueda usando el valor de 'query'
  //   // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
  //   setCreateCisModalOpen(true);
  // };
  function closCreateCisModal() {
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const handleChangEdit = (cis) => {
    setEditActive(true);
    buscar_cis(cis.element_id);
  };
  useEffect(() => {
    // search_devices();
  }, []);
  const buscar_cis = (ci_id) => {
    setLoadingCis(true);
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/ci_elements/" +
            ci_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setLoadingCis(false);
          setDataCis(data1.data);
          setCreateCisModalOpen(true);
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const regresar_cis = () => {
    setCisSelected([]);
    // setLoadingCis(true)
  };

  const generatePDF = () => {
    const input = document.getElementById("content");

    // Guardar el estado actual de visibilidad de los elementos que deseas ocultar
    const originalDisplay = [];
    const elementsToHide = input.querySelectorAll(".hiddenPDF");
    elementsToHide.forEach((element) => {
      originalDisplay.push(element.style.display);
      element.style.display = "none";
    });

    html2canvas(input).then((canvas) => {
      // Restaurar el estado original de visibilidad
      elementsToHide.forEach((element, index) => {
        element.style.display = originalDisplay[index];
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "PNG", 10, 10, 190, 100);
      pdf.save("CIs-" + obtenerFechaActualLocal() + ".pdf");
    });
  };

  function search_devices() {
    setDevices({ data: devices.data, loading: true, error: devices.error });

    const fetchData = async () => {
      try {
        //console.log(`Bearer ${token_item}`)
        const token =
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY"; // Reemplaza con tu token de autenticación
        // const response = await fetch(server.url+'/api/v1/zabbix/db/hosts/relations/'+ubicacion.groupid, {
        const devicefilter = "";
        const subtypefilter = "";
        let andAux = devicefilter !== "" ? "&" : "?";
        andAux = subtypefilter !== "" ? andAux : "";
        const response = await fetch(
          server.url + "/api/v1/zabbix/hosts/0",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.ok) {
          const response_data = await response.json();
          setDevices({
            data: response_data.data,
            loading: false,
            error: devices.error,
          });
          setLoadingCis(false);
        } else {
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        // Manejo de errores
        setDevices({
          data: devices.data,
          loading: devices.loading,
          error: error,
        });
        //console.error(error);
      }
    };
    fetchData();
  }
  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };
  return (
    <>
    <div className="head-cis">
        <div className="title-cis">
          <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    onSearch={handleSearch}
                    dataObject={dataUsers.data}
                    setDataObject={setDataUsers}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />
          <div className={"cont-result-registers"+mode}>
         
                  <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList.length +
                      ") " 
                      }
                  </p> 
          </div>
          <div className="cont-buttons-panel">
                  
                    <Action
                    disabled={false}
                    origen="Azul"
                    titulo={capitalizeFirstLetter(lang[languaje]['solicitar'])}
                    action={crear}
                  />
                  
                 
                </div>
        </div>
      </div>
      
            <div className='cont-cis'>
            <>
      <div className="main-panel-cis">
      <div className="compact-content-portafolio">
        
      <div className={"content-portafolio-head"+mode}>
              {/* {ServiceSelected.length === 0 ? '':
                <>
                <div
                  className="cont-btn-back-users"
                  style={{ width: "10%" }}
                  onClick={regresar_cis}
                >
                  <div className="cont-img-back-users">
                    <img
                      className="img-back-users"
                      src={"/iconos/back.png"}
                      name="regresar"
                    />
                  </div>
                  <div className="cont-txt-back-users">
                    <div className="txt-back-users">{capitalizeFirstLetter(lang[languaje]['regresar'])}</div>
                  </div>
                </div>
                <div className="txt-back-users sla-content">{ServiceSelected.service_name }&nbsp;&nbsp;&nbsp;&nbsp;{ '     SLA: '+sla+"%"}</div>
              </>
                } */}
              
        </div>
        <div className="content-portafolio">
          

          <div className="cont-portafolio-table">

            <div className="content-card-portafolio" id="content">
              {false? (
                <LoadSimple />
              ) : (
                <>
                  {/* {cisSelected.length === 0 ? ( */}
                    <TableCis
                      pageActual={pageActual}
                       limitList={limitList} startLimit={startLimit}
                      dataList={dataList}
                      cisSelected={cisSelected}
                      setCisSelected={setCisSelected}
                      registerIsValid={registerIsValid}
                      searchResults={searchResults}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      dataUsers={dataUsers}
                      setDataUsers={setDataUsers}
                      server={server}
                      setRegisterIsValid={setRegisterIsValid}
                      setData={setData}
                      setLoading={setLoading}
                      setError={setError}
                      handleChangEdit={handleChangEdit}
                      devices={devices}
                      languaje={languaje}
                      mode={mode}
                      handleShowPopup={handleShowPopup}
                    ></TableCis>
                
                    
                </>
              )}
            </div>
          </div>
        </div>
        <div className={"content-portafolio-footer"+mode}>
          <div className="cont-display-paginador">
                    <Paginador  pages={pages}
                                pageActual={pageActual}
                                setPageActual={setPageActual}
                                mode={mode}></Paginador>
          </div>
          <div className="cont-display-paginador">
            <div className={"cont-half-display-paginador"+mode}>
            <div>
      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
      <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
        <option value={10}>10</option>
        <option value={50} >50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
        <option value={1000}>1000</option>
      </select>

      
    </div>
                  
            </div>
            <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                          ?  parseInt(pageActual ) * parseInt(limitList)
                          : dataList.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList.length +
                        " "+lang[languaje]['resultados']}
                      </p>
                  
            </div>
          </div>  
                    
        </div>
        </div>
      </div>
      </>
                
                
            </div>
      <Modal
        isOpen={CreateCisModalOpen}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closCreateCisModal}
        style={CreateCisModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
      >
        <ModalCreateCis
          devices={devices}
          server={server}
          editActive={editActive}
          setEditActive={setEditActive}
          dataCis={dataCis}
          setData={setData}
          loading={loading}
          setLoading={setLoading}
          setError={setError}
          setRegisterIsValid={setRegisterIsValid}
          closCreateCisModal={closCreateCisModal}
          languaje={languaje}
          mode={mode}
          handleShowPopup={handleShowPopup}
        ></ModalCreateCis>
      </Modal>
    </>
  );
};

export default PanelProvSoft;
